<div class="info-panel flex gap-1" infoPanel [control]="control" [value]="value">
    <div class="info-title text-gray-500"> {{ description | translate }} </div>
    <div class="font-bold info-value text-gray-900"> {{ format(value) }} </div>
</div>